import { render, staticRenderFns } from "./MyCourse.vue?vue&type=template&id=fc73af90&scoped=true&"
import script from "./MyCourse.vue?vue&type=script&lang=js&"
export * from "./MyCourse.vue?vue&type=script&lang=js&"
import style0 from "./MyCourse.vue?vue&type=style&index=0&id=fc73af90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc73af90",
  null
  
)

export default component.exports